import { Injectable } from '@angular/core';

import { CoreModule } from './core.module';

function getWindow() {
    return window;
}

@Injectable({
  providedIn: CoreModule,
})
export class WindowRefService {

  constructor() { }

  get nativeWindow(): any {
      return getWindow();
  }
}
